import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment, useState, useEffect, useMemo } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, Col, Row, CardFooter } from "reactstrap";
import ReactTableGeneric from "Components/ReactTableGeneric";
import { ReactComponent as PdfIcon } from "../../../../assets/utils/images/svgs/PDF.svg";
import Loader from "react-loaders";
import { useDownloadTravelCost, useTravelCosts, useTravelCostsByCommunity } from "Api/Vervanger/TravelCost";
import { downloadBase64File } from "helperFunctions";

const Default = () => {
  const [selectedCommunityId, setSelectedCommunityId] = useState(null);
  const [downloadData, setDownloadData] = useState({
    id: null,
    type: null,
  });


  const columns = useMemo(
    () => [
      {
        header: "Organisatie",
        accessorKey: "organization",
        cell: ({ row }) => <div>{row.original.organization}</div>,
      },
      {
        header: () => 'Periode',
        accessorKey: 'periode',
        cell: (value) => (
          <div>
            {value.row.original.periode ? (value.row.original.periode) :
              (value.row.original.startDate + " tot " + value.row.original.endDate)}
          </div>
        )
      },
      {
        header: "Aanmaakdatum",
        accessorKey: "created_at",
        cell: ({ row }) => <div>{row.original.created_at}</div>,
      },
      {
        header: "Bedrag",
        accessorKey: "vPrice",
        cell: ({ row }) => {
          const formatPrice = (price) => {
            if (typeof price !== 'number') {
              price = parseFloat(price);
            }

            if (isNaN(price)) {
              return '0,00';
            }

            return price.toFixed(2).replace('.', ',');
          };

          const formattedPrice = formatPrice(row.original.vPrice);

          return <div>€ {formattedPrice}</div>;
        },
      },
      {
        header: "Download",
        accessorKey: "file",
        cell: ({ row }) => (
          <a href="javascript:void(0)" onClick={() => downloadDocument(row.original.id, "pdf")}>
            <PdfIcon />
          </a>
        ),
      },
    ],
    []
  );

  const {
    trigger: getTravelCosts,
    data: travelCostResponse,
    isMutating: isLoading,
  } = useTravelCosts();

  const totalCount=travelCostResponse?.data?.totalCount;

  useEffect(() => {
    getTravelCosts({
      data: selectedCommunityId
        ? { communityId: selectedCommunityId }
        : {},
    });
  }, []);

  const communities =
    travelCostResponse?.data?.communityList?.map(
      (item) => ({
        id: item.iCommunityId,
        name: item.name,
      })
    ) || [];


  useEffect(() => {
    if (
      communities.length > 0 &&
      !selectedCommunityId
    ) {
      setSelectedCommunityId(
        communities[0].id
      );
    }
  }, [communities, selectedCommunityId]);

  // const {
  //   data: filteredResponse,
  // } = useTravelCostsByCommunity(
  //   selectedCommunityId
  // );
  const data =
    travelCostResponse?.data?.travelcostList ||
    [];



  const { data: downloadResponse } = useDownloadTravelCost(
    downloadData.id,
    downloadData.type
  );

  const downloadDocument = (id, type) => {
    setDownloadData({
      id,
      type,
    });
  };

  

  useEffect(() => {
    if (!downloadResponse) return;

    const fileData = downloadResponse?.data?.substitutor?.file;

    if (fileData?.download) {
      downloadBase64File(
        fileData.download,
        `travelcost_${downloadData.id}.${downloadData.type}`
      );
    }
  }, [downloadResponse]);


  return (
    <Fragment>
      <PageHeading />
      <TransitionOnLoad>
        <Row>
          <Col md="12" lg="12">
            <Card className="main-card mb-3">
              <CardBody className="p-3 table-responsive">

                {isLoading ? (
                  <Loader
                    type="ball-grid-pulse"
                    className="mt-3 d-flex mx-auto justify-content-center"
                  />
                ) : (
                  <>
                    <ReactTableGeneric
                      data={data}
                      columns={columns}
                      filters={{ search: false, pagination: true, sorting: true }}
                      tableClassName="mb-0 table table-sm table-hover table-borderless"
                      count={totalCount}
                    />
                  </>
                )}

              </CardBody>
            </Card>
          </Col>
        </Row>
      </TransitionOnLoad>
      <div className="chat-layout-footer verzoken-footer-height">
        <CardFooter className="d-block d-flex chat-layout-footer__inner">
          <div className="d-flex justify-content-end mb-3">
            <select
              className="form-select"
              value={selectedCommunityId || ""}
              onChange={(e) =>
                setSelectedCommunityId(Number(e.target.value))
              }
            >
              <option value="" disabled>
                Organisaties
              </option>

              {communities.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
        </CardFooter>
      </div>
    </Fragment>
  );
};

export default Default;
